
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"sinistre_clos","data-name":"sinistre clos"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M34.24 7.13L21.16 18.89a2 2 0 01-2.68 0L5.39 7.13a.65.65 0 10-.87 1l13.09 11.73a3.36 3.36 0 004.42 0L35.11 8.09a.64.64 0 000-.91.65.65 0 00-.87-.05zM13.31 20.09l-8.77 7.3a.65.65 0 00-.08.91.62.62 0 00.5.23.6.6 0 00.41-.15l8.77-7.29a.65.65 0 00-.83-1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M35.1 3.06H4.88A4.43 4.43 0 00.37 7.5V28a4.42 4.42 0 004.51 4.43h11a.65.65 0 000-1.3h-11A3.14 3.14 0 011.67 28V7.5a3.14 3.14 0 013.21-3.14H35.1a3.15 3.15 0 013.23 3.14V28a3.06 3.06 0 01-2 2.95.65.65 0 00.43 1.23A4.35 4.35 0 0039.63 28V7.5a4.49 4.49 0 00-4.53-4.44z"}}),_c('path',{attrs:{"d":"M29.14 30.3v-2s.2-3.87-4.8-2.1","fill":"none","stroke":"#ff7400","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}}),_c('path',{attrs:{"d":"M29 29.53a.65.65 0 00.81-.45.66.66 0 00-.46-.8c-.39-.11-3.88-1-5.45.3a2.22 2.22 0 00-.73 2.07 2.56 2.56 0 002.75 2.41 4.86 4.86 0 003-1.11 2.2 2.2 0 002 1.11A3.19 3.19 0 0033.33 32a4.88 4.88 0 001.09-3.76 7.86 7.86 0 10-3.18 7.21.65.65 0 00.14-.91.64.64 0 00-.9-.15 6.51 6.51 0 112.64-6 3.58 3.58 0 01-.75 2.75 1.92 1.92 0 01-1.47.65 1 1 0 01-.79-.28 1.63 1.63 0 01-.32-1.12.65.65 0 00-1.3-.12c-.06.64-1.36 1.51-2.61 1.52a1.26 1.26 0 01-1.43-1.25c-.07-.58.12-.82.27-.94.77-.7 3.02-.41 4.28-.07z","fill":"#ff7400"}})])])
          )
        }
      }
    